import { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthProvider";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [showPassword, setShowPassword] = useState(false);
  // login
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (!executeRecaptcha) {
        toast("Please complete the CAPTCHA!");
        return;
      }
      // CHECK CATPCHA
      const recaptchaToken = await executeRecaptcha("submit");
      const user = await login(username, password, recaptchaToken);
      if (user) {
        toast.success(`Welcome, ${user.username}`);
        // UserConfigProvider will automatically refetch when user changes
      }
    } catch (error) {
      toast.error(`Error: ${error}`);
    }
  };

  const NavToRegister = () => {
    navigate("/register");
  };
  const NavToForgotPassword = () => {
    navigate("/forgot-password");
  };
  return (
    <div className="bg-base-200 h-full flex flex-col justify-center items-center animate-fade-in">
      <div className="card bg-base-100 m-2 w-full shadow-lg sm:w-96">
        <div className="card-body">
          <h2 className="card-title ">Login</h2>
          <form onSubmit={handleLogin} className="flex flex-col gap-4">
            <input
              className="input input-bordered"
              placeholder="username"
              value={username}
              autoComplete="username"
              onChange={(e) => setUsername(e.target.value)}
            />
            <label className="input input-bordered flex items-center gap-2 justify-between">
              <input
                placeholder="password"
                type={showPassword ? "text" : "password"}
                value={password}
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                onClick={() => setShowPassword(!showPassword)}
                className={`btn btn-sm btn-ghost ${
                  showPassword ? "text-primary" : ""
                }`}
              >
                {showPassword ? <FiEye size={20} /> : <FiEyeOff size={20} />}
              </div>
            </label>

            <button
              className="btn btn-primary"
              onClick={handleLogin}
              type="submit"
            >
              Submit
            </button>
            <div className="flex flex-row justify-center">
              <button
                className="flex btn btn-ghost text-primary "
                onClick={NavToRegister}
              >
                Register
              </button>
              <button
                className="flex btn btn-ghost text-primary"
                onClick={NavToForgotPassword}
              >
                Forgot Password?
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
